// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ACt1","rightAdornment":"Header_rightAdornment__DjjOf"};